import { render, staticRenderFns } from "./bannerTop.vue?vue&type=template&id=0b87fab4&scoped=true"
import script from "./bannerTop.vue?vue&type=script&lang=js"
export * from "./bannerTop.vue?vue&type=script&lang=js"
import style0 from "./bannerTop.vue?vue&type=style&index=0&id=0b87fab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87fab4",
  null
  
)

export default component.exports